import type { CardInstance, RunState } from "../types/index.js";
import { lookupCard } from "../../content/cards.js";

export function discardPlayed(run: RunState, retainTasks = false): RunState {
  const retained = retainTasks ? run.hand.filter((card) => lookupCard(card.cardId)?.retainedFatigue) : [];
  const moved = [...run.hand.filter((card) => !retained.includes(card)), ...run.inPlay, ...run.aside];
  if (moved.length === 0) {
    return { ...run, hand: retained, inPlay: [], aside: [] };
  }
  return {
    ...run,
    hand: retained,
    inPlay: [],
    aside: [],
    discard: [...run.discard, ...moved],
  };
}

export function removeFromHand(hand: CardInstance[], instanceId: string): {
  hand: CardInstance[];
  card: CardInstance | null;
} {
  const index = hand.findIndex((c) => c.instanceId === instanceId);
  if (index < 0) return { hand, card: null };
  const card = hand[index];
  const next = hand.slice();
  next.splice(index, 1);
  return { hand: next, card };
}
